<div class="bg-white rounded-lg overflow-hidden border">
    <ul autoAnimate class="divide-y">
        @if (canSeeTotal()) {
            <li
                role="button"
                tabindex="0"
                (keydown.enter)="selectTotal()"
                (keydown.space)="$event.preventDefault(); selectTotal()"
                (click)="selectTotal()"
                class="px-6 py-3 cursor-pointer flex space-x-3 items-center hover:bg-gray-50 active:bg-gray-100 font-medium"
            >
                <div>
                    {{ totalName }}
                    <span class="ml-2 text-xs font-normal text-muted">alle vestigingen samen</span>
                </div>
            </li>
        }
        @for (establishment of establishments(); track establishment.id) {
            <li
                role="button"
                tabindex="0"
                (keydown.enter)="selectEstablishment(establishment)"
                (keydown.space)="$event.preventDefault(); selectEstablishment(establishment)"
                (click)="selectEstablishment(establishment)"
                class="px-6 py-3 cursor-pointer flex space-x-3 items-center hover:bg-gray-50 active:bg-gray-100"
            >
                <div>
                    {{ establishment.name }}
                </div>
            </li>
        }
    </ul>
</div>